module.exports = __webpack_public_path__ + "static/logo1-6ed8bacb90bbdfba7278d0953180b85e.png";